import {router} from '@/router'
import store from '@/store'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import { getUserInfo } from '@/api/login'
import Cookies from 'js-cookie'
import {getToken} from '@/utils/auth'
import * as tools from '@/utils/tools'

const hasPermission = (roles, permissionRoles) => {
  if (roles.indexOf('admin') !== -1) return true
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) !== -1)
}

const whiteList = ['/login', '/roadLogin']

router.beforeEach(async (to, from, next) => {
  nprogress.start();
  // 根据 roles 权限生成路由表
  var url = document.location.href
  if (getToken()) {
    const response = await getUserInfo(Cookies.get('user'))
    let path = response&&response.data&&response.data.menuList[0]&&response.data.menuList[0].libList[0].pageUrl||'/';
    // 如果登录过后访问登录页面则跳回主页  热力图登陆页面/roadLogin
    if (to.path === '/login' || to.path === '/roadLogin') {
      if (to.path == '/roadLogin') {
        const response = await getUserInfo(Cookies.get('user'))
        if(response.code==200){
          const { menuList } = response.data||[]
          var libList = menuList[menuList.length - 1]
          if (libList.id !== 415) {
            tools.notify({
              type: 'error',
              message: '抱歉，该手机号码无访问权限'
            })
          } else {
            next({
              path: '/roadOperation/allRoad'
            })
          }
        }else{
          next({
            path: '/roadLogin'
          })
        }
      } else {
        next({
          path: path
        })
      }
      nprogress.done()
    } else {
      // 请求用户信息，通过 roles 动态获取路由
      if (store.getters.menuList && store.getters.menuList.length === 0) {
        try {
          const infoResponse = await store.dispatch('getUserInfo')
          const {
            menuList,
            userType
          } = infoResponse.data
          // 根据 roles 权限生成路由表
          await store.dispatch('generateRoutes', {
            userType,
            menuList
          })
          // 动态新生成的路由表
          router.addRoutes(store.getters.addRouters)
          next({
            ...to,
            replace: true
          })
        } catch (error) {
          await store.dispatch('felogout')
          tools.notify({
            type: 'error',
            message: 'Verification failed, please login again'
          })
          next({
            path: path
          })
        }
      } else {
        // 如有 roles 则通过与路由 meta 的 roles 判断是否有访问该路由的权限
        if (hasPermission(store.getters.menuList, to.meta.roles)) {
          next()
        } else {
          next({
            path: '/401',
            replace: true,
            query: {
              noGoBack: true
            }
          })
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 热力图页面跳转到登陆页面
      if (url.indexOf("roadOperation") !== -1) {
        next('/roadLogin')
      } else {
        next('/login')
      }
      // next()
      // return
      nprogress.done() // 如果当前页是 login 则路由不会触发 after 钩子函数，需要手动处理
    }
  }
})

router.afterEach(async (to) => {
  if (getToken()) {
    try {
      const infoResponse = await store.dispatch('getUserInfo');
      const {
        userType,
        areaList
      } = infoResponse.data;
      if (userType == 2) { //如果是地市级用户    
        let routerList = ['/cardMap'];
        if (routerList.indexOf(to.path) != -1) {
          vm.$router.replace({
            name: "cardProvince",
            query: {
              provinceCode: areaList[0].provinceCode,
              provinceName: areaList[0].provinceName
            }
          })
        }
      }
    } catch (error) {
      new Error(error);
    }
  }
  nprogress.done()
})